import { GetServerSideProps } from 'next';
import { trackUserEvent } from '../utils/trackUserEvent';

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  await trackUserEvent({
    ctx,
  });
  const { locale } = ctx;

  return {
    props: {
      locale: locale || 'pt',
    },
  };
};

export default function Terms({ locale }: { locale: string }) {
  return (
    <>
      <p
        style={{
          marginRight: '0cm',
          marginLeft: '0cm',
          fontSize: '11.0pt',
          fontFamily: 'Calibri, sans-serif',
          marginTop: '0cm',
          marginBottom: '8.0pt',
          margin: '0cm 0cm 8pt',
          lineHeight: 'normal',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'center',
          verticalAlign: 'baseline',
        }}
      >
        <strong>
          <span style={{ fontSize: 16 }}>ADSTART</span>
        </strong>
      </p>
      <p
        style={{
          marginRight: '0cm',
          marginLeft: '0cm',
          fontSize: '11.0pt',
          fontFamily: 'Calibri, sans-serif',
          marginTop: '0cm',
          marginBottom: '8.0pt',
          margin: '0cm 0cm 8pt',
          lineHeight: 'normal',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'center',
          verticalAlign: 'baseline',
        }}
      >
        <strong>
          <span style={{ fontSize: 16 }}>
            {locale === 'en'
              ? 'GENERAL TERMS AND CONDITIONS OF USE'
              : 'TERMOS GERAIS E CONDIÇÕES DE USO'}
          </span>
        </strong>
      </p>
      <p
        style={{
          marginRight: '0cm',
          marginLeft: '0cm',
          fontSize: '11.0pt',
          fontFamily: '"Times New Roman", serif',
          marginTop: '0cm',
          marginBottom: '8.0pt',
          margin: '0cm 0cm 18pt',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textAlign: 'start',
          textIndent: 0,
          textDecoration: 'none',
          backgroundColor: 'white',
        }}
      >
        <span style={{ fontFamily: 'Calibri, sans-serif', color: 'black' }}>
          {locale === 'en'
            ? 'For the ADSTART platform to achieve its objectives, it is essential that all users respect the Terms and Conditions of Use presented below.'
            : 'Para que a plataforma ADSTART alcance seus objetivos, é fundamental que todos seus usuários respeitem os Termos e Condições de Uso, apresentados a seguir.'}
        </span>
      </p>
      <p
        style={{
          marginRight: '0cm',
          marginLeft: '0cm',
          fontSize: '11.0pt',
          fontFamily: 'Calibri, sans-serif',
          marginTop: '0cm',
          marginBottom: '8.0pt',
          margin: '0cm 0cm 8pt',
          lineHeight: 'normal',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
          verticalAlign: 'baseline',
        }}
      >
        <span style={{ fontSize: 16, color: 'black' }}>
          {locale === 'en'
            ? 'This instrument contains the general terms and conditions of use of the website '
            : 'Este instrumento contém os termos gerais e condições de uso do website '}
        </span>
        <a
          href="https://adstart.com.br/"
          style={{ color: 'rgb(149, 79, 114)', textDecoration: 'underline' }}
        >
          <span style={{ fontSize: 16 }}>https://adstart.com.br/</span>
        </a>
        <span style={{ fontSize: 16, color: 'black' }}>
          {locale === 'en'
            ? ' and the services provided by the ADSTART platform.'
            : ' e dos serviços disponibilizados pela plataforma ADSTART.'}
        </span>
      </p>
      <p
        style={{
          marginRight: '0cm',
          marginLeft: '0cm',
          fontSize: 15,
          fontFamily: 'Calibri, sans-serif',
          margin: '0cm',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textAlign: 'start',
          textIndent: 0,
          textDecoration: 'none',
        }}
      >
        <span style={{ fontSize: 16 }}>&nbsp;</span>
      </p>
      <p
        style={{
          marginRight: '0cm',
          marginLeft: '0cm',
          fontSize: '11.0pt',
          fontFamily: 'Calibri, sans-serif',
          marginTop: '0cm',
          marginBottom: '8.0pt',
          margin: '0cm 0cm 8pt',
          lineHeight: 'normal',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
          verticalAlign: 'baseline',
        }}
      >
        <strong>
          <span style={{ fontSize: 16 }}>
            {locale === 'en'
              ? 'Use and Acceptance of Platform Terms of Use'
              : 'Uso e Aceitação das Condições de Uso da Plataforma'}
          </span>
        </strong>
      </p>
      <p
        style={{
          marginRight: '0cm',
          marginLeft: '0cm',
          fontSize: '11.0pt',
          fontFamily: 'Calibri, sans-serif',
          marginTop: '0cm',
          marginBottom: '8.0pt',
          margin: '0cm 0cm 8pt',
          lineHeight: 'normal',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
          verticalAlign: 'baseline',
        }}
      >
        {locale === 'en' ? (
          <span style={{ fontSize: 16 }}>
            ADSTART is a B2B business model Platform owned by{' '}
            <strong>LAX LTDA</strong> - CNPJ No. 39.429.495/0001-04, which
            centralizes all customer e-commerce data in one place, saving time
            with focus on results.
          </span>
        ) : (
          <span style={{ fontSize: 16 }}>
            A ADSTART é uma Plataforma modelo de negócio B2B de propriedade da{' '}
            <strong>LAX LTDA</strong> - CNPJ nº 39.429.495/0001-04, que
            centraliza todos os dados do e-commerce do cliente em um só lugar,
            economizando tempo com foco no resultado.
          </span>
        )}
      </p>
      <p
        style={{
          marginRight: '0cm',
          marginLeft: '0cm',
          fontSize: '11.0pt',
          fontFamily: 'Calibri, sans-serif',
          marginTop: '0cm',
          marginBottom: '8.0pt',
          margin: '0cm 0cm 8pt',
          lineHeight: 'normal',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
          verticalAlign: 'baseline',
        }}
      >
        {locale === 'en' ? (
          <>
            <span style={{ fontSize: 16, color: 'black' }}>
              The use of ADSTART Services is governed by these&nbsp;
            </span>
            <span style={{ fontSize: 16 }}>
              GENERAL TERMS AND CONDITIONS OF USE&nbsp;
            </span>
            <span style={{ fontSize: 16 }}>
              and users must read them carefully before using the provided
              services.
            </span>
          </>
        ) : (
          <>
            <span style={{ fontSize: 16, color: 'black' }}>
              O uso dos Serviços da&nbsp;
            </span>
            <span style={{ fontSize: 16 }}>
              ADSTART é regido por estes&nbsp;
            </span>
            <span style={{ fontSize: 16 }}>
              TERMOS GERAIS E CONDIÇÕES DE USO&nbsp;
            </span>
            <span style={{ fontSize: 16 }}>
              e o usuário deve ler atentamente antes de utilizar os serviços
              disponibilizados.
            </span>
          </>
        )}
      </p>
      <p
        style={{
          marginRight: '0cm',
          marginLeft: '0cm',
          fontSize: '11.0pt',
          fontFamily: 'Calibri, sans-serif',
          marginTop: '0cm',
          marginBottom: '8.0pt',
          margin: '0cm 0cm 8pt',
          lineHeight: 'normal',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
          verticalAlign: 'baseline',
        }}
      >
        {locale === 'en' ? (
          <>
            <span style={{ fontSize: 16, color: 'black' }}>
              By accessing and registering on the website&nbsp;
            </span>
            <a
              href="https://adstart.com.br/"
              style={{
                color: 'rgb(149, 79, 114)',
                textDecoration: 'underline',
              }}
            >
              <span style={{ fontSize: 16 }}>https://adstart.com.br/</span>
            </a>
            <span style={{ fontSize: 16, color: 'black' }}>
              &nbsp;the user expressly agrees to these&nbsp;
            </span>
            <span style={{ fontSize: 16 }}>general terms&nbsp;</span>
            <span style={{ fontSize: 16, color: 'black' }}>
              and conditions, whereby they commit to respect and comply with all
              provisions, policies and legal notices that regulate the access
              and use of the website and services provided.
            </span>
          </>
        ) : (
          <>
            <span style={{ fontSize: 16, color: 'black' }}>
              Ao acessar e registrar o website&nbsp;
            </span>
            <a
              href="https://adstart.com.br/"
              style={{
                color: 'rgb(149, 79, 114)',
                textDecoration: 'underline',
              }}
            >
              <span style={{ fontSize: 16 }}>https://adstart.com.br/</span>
            </a>
            <span style={{ fontSize: 16, color: 'black' }}>
              &nbsp;o usuário manifesta sua expressa concordância com
              estes&nbsp;
            </span>
            <span style={{ fontSize: 16 }}>termos gerais&nbsp;</span>
            <span style={{ fontSize: 16, color: 'black' }}>
              e suas condições, pelo que se compromete a respeitar e cumprir
              todas as disposições, políticas e avisos legais que regulamentam o
              aceso e a utilização do website e dos serviços disponibilizados.
            </span>
          </>
        )}
      </p>
      <p
        style={{
          marginRight: '0cm',
          marginLeft: '0cm',
          fontSize: '11.0pt',
          fontFamily: 'Calibri, sans-serif',
          marginTop: '0cm',
          marginBottom: '8.0pt',
          margin: '0cm 0cm 8pt',
          lineHeight: 'normal',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
          verticalAlign: 'baseline',
        }}
      >
        {locale === 'en' ? (
          <span style={{ fontSize: 16 }}>
            These GENERAL TERMS AND CONDITIONS OF USE constitute a binding
            contract between ADSTART and the user. If you do not agree with the
            established conditions, do not use the platform and the services
            provided.
          </span>
        ) : (
          <>
            <span style={{ fontSize: 16, color: 'black' }}>Estes&nbsp;</span>
            <span style={{ fontSize: 16 }}>
              TERMOS GERAIS E CONDIÇÕES DE USO&nbsp;
            </span>
            <span style={{ fontSize: 16 }}>
              constituem contrato vinculante entre a&nbsp;ADSTART&nbsp;e o
              usuário. Caso você não concorde com as condições estabelecida não
              utilize a plataforma e os serviços disponibilizados.
            </span>
          </>
        )}
      </p>
      <p
        style={{
          marginRight: '0cm',
          marginLeft: '0cm',
          fontSize: '11.0pt',
          fontFamily: 'Calibri, sans-serif',
          marginTop: '0cm',
          marginBottom: '8.0pt',
          margin: '0cm 0cm 8pt',
          lineHeight: 'normal',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
          verticalAlign: 'baseline',
        }}
      >
        {locale === 'en' ? (
          <>
            <span style={{ fontSize: 16, color: 'black' }}>
              At any time,&nbsp;
            </span>
            <span style={{ fontSize: 16 }}>
              ADSTART may update or modify these&nbsp;
            </span>
            <span style={{ fontSize: 16 }}>
              GENERAL TERMS AND CONDITIONS OF USE.&nbsp;
            </span>
            <span style={{ fontSize: 16 }}>
              The modifications and/or updates will be published on the
              website&nbsp;
            </span>
            <a
              href="https://adstart.com.br/"
              style={{
                color: 'rgb(149, 79, 114)',
                textDecoration: 'underline',
              }}
            >
              <span style={{ fontSize: 16 }}>https://adstart.com.br/</span>
            </a>
            <span style={{ fontSize: 16 }}>
              &nbsp;and your continued use expresses your explicit agreement
              with the modified and/or updated terms.
            </span>
          </>
        ) : (
          <>
            <span style={{ fontSize: 16, color: 'black' }}>
              A qualquer tempo a&nbsp;
            </span>
            <span style={{ fontSize: 16 }}>
              ADSTART pode atualizar ou alterar estes&nbsp;
            </span>
            <span style={{ fontSize: 16 }}>
              TERMOS GERAIS E CONDIÇÕES DE USO.&nbsp;
            </span>
            <span style={{ fontSize: 16 }}>
              As alterações e/ou atualizações serão publicadas no website&nbsp;
            </span>
            <a
              href="https://adstart.com.br/"
              style={{
                color: 'rgb(149, 79, 114)',
                textDecoration: 'underline',
              }}
            >
              <span style={{ fontSize: 16 }}>https://adstart.com.br/</span>
            </a>
            <span style={{ fontSize: 16 }}>
              &nbsp;e seu uso continuado expressa sua concordância expressa com
              os termos alterados e/ou atualizados.
            </span>
          </>
        )}
      </p>
      <p
        style={{
          marginRight: '0cm',
          marginLeft: '0cm',
          fontSize: '11.0pt',
          fontFamily: 'Calibri, sans-serif',
          marginTop: '0cm',
          marginBottom: '8.0pt',
          margin: '0cm 0cm 8pt',
          lineHeight: 'normal',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
          verticalAlign: 'baseline',
        }}
      >
        <strong>
          <span style={{ fontSize: 16 }}>
            &nbsp;Acesso à Plataforma e aos Serviços Disponibilizados
          </span>
        </strong>
      </p>
      <p
        style={{
          marginRight: '0cm',
          marginLeft: '0cm',
          fontSize: '11.0pt',
          fontFamily: 'Calibri, sans-serif',
          marginTop: '0cm',
          marginBottom: '8.0pt',
          margin: '0cm 0cm 8pt',
          lineHeight: 'normal',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
          verticalAlign: 'baseline',
        }}
      >
        {locale === 'en' ? (
          <>
            <span style={{ fontSize: 16, color: 'black' }}>
              Website access and use of the platform and services provided
              depend on necessary and compatible software and hardware. The user
              is solely and exclusively responsible for maintaining any and all
              software and hardware necessary to access the website and use the
              services provided.&nbsp;
            </span>
            <span style={{ fontSize: 16 }}>ADSTART</span>
            <span style={{ fontSize: 16, color: 'black' }}>
              &nbsp;is not responsible for any technical difficulties arising
              from the use of incompatible technology.
            </span>
          </>
        ) : (
          <>
            <span style={{ fontSize: 16, color: 'black' }}>
              O acesso do website e o uso da plataforma e dos serviços
              disponibilizados dependem de software e hardware necessários e
              compatíveis. O usuário é o único e exclusivo responsável por
              manter todo e qualquer software e hardware necessários para
              acessar o website e utilizar os serviços disponibilizados. A&nbsp;
            </span>
            <span style={{ fontSize: 16 }}>ADSTART</span>
            <span style={{ fontSize: 16, color: 'black' }}>
              &nbsp;não se responsabiliza por quaisquer dificuldades técnicas
              decorrentes do uso de tecnologia incompatível.
            </span>
          </>
        )}
      </p>
      <p
        style={{
          marginRight: '0cm',
          marginLeft: '0cm',
          fontSize: '11.0pt',
          fontFamily: 'Calibri, sans-serif',
          marginTop: '0cm',
          marginBottom: '8.0pt',
          margin: '0cm 0cm 8pt',
          lineHeight: 'normal',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
          verticalAlign: 'baseline',
        }}
      >
        <strong>
          <span style={{ fontSize: 16 }}>
            {locale === 'en' ? 'Access and Registration' : 'Acesso e Cadastro'}
          </span>
        </strong>
      </p>
      <p
        style={{
          marginRight: '0cm',
          marginLeft: '0cm',
          fontSize: '11.0pt',
          fontFamily: 'Calibri, sans-serif',
          marginTop: '0cm',
          marginBottom: '8.0pt',
          margin: '0cm 0cm 8pt',
          lineHeight: 'normal',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
          verticalAlign: 'baseline',
        }}
      >
        {locale === 'en' ? (
          <span style={{ fontSize: 16, color: 'black' }}>
            Website access is free and independent of registration and login. To
            use the free services with a 14-day free trial or paid services,
            prior registration will be required with the provision of email,
            name and phone number.&nbsp;&nbsp;By accessing, the user agrees to
            provide correct information in the format of the form provided,
            under penalty of liability under the law.
          </span>
        ) : (
          <span style={{ fontSize: 16, color: 'black' }}>
            O acesso ao website é feito de forma livre e independente do
            cadastro e login. Para uso dos serviços gratuitos com teste grátis
            por 14 dias u aos serviços pagos, será necessário cadastro prévio
            com o fornecimento do e-mail, nome e telefone.&nbsp;&nbsp;Ao
            acessar, o usuário concorda em fornecer informações corretas no
            formato do formulário disponibilizado, sob pena de responsabilidade
            nos termos da lei.
          </span>
        )}
      </p>
      <p
        style={{
          marginRight: '0cm',
          marginLeft: '0cm',
          fontSize: '11.0pt',
          fontFamily: 'Calibri, sans-serif',
          marginTop: '0cm',
          marginBottom: '8.0pt',
          margin: '0cm 0cm 8pt',
          lineHeight: 'normal',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
          verticalAlign: 'baseline',
        }}
      >
        {locale === 'en' ? (
          <span style={{ fontSize: 16, color: 'black' }}>
            The user will provide their data and the access request will be
            forwarded to ADSTART, which will approve the registration and
            release the first access via email. The User must replace the
            default password sent.
          </span>
        ) : (
          <>
            <span style={{ fontSize: 16, color: 'black' }}>
              O usuário fornecerá seus dados e a solicitação de acesso será
              encaminhada para a&nbsp;
            </span>
            <span style={{ fontSize: 16 }}>
              ADSTART que fará a aprovação do cadastro e a liberação do primeiro
              acesso via e-mail. O Usuário deverá substituir a senha padrão
              enviada.&nbsp;
            </span>
          </>
        )}
      </p>
      <p
        style={{
          marginRight: '0cm',
          marginLeft: '0cm',
          fontSize: '11.0pt',
          fontFamily: 'Calibri, sans-serif',
          marginTop: '0cm',
          marginBottom: '8.0pt',
          margin: '0cm 0cm 8pt',
          lineHeight: 'normal',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
          verticalAlign: 'baseline',
        }}
      >
        {locale === 'en' ? (
          <span style={{ fontSize: 16 }}>
            Registration and access data are personal and non-transferable and
            the user is solely responsible for maintaining the confidentiality
            of their data and the activities and services used on the
            Platform.&nbsp;
          </span>
        ) : (
          <span style={{ fontSize: 16 }}>
            Os dados de cadastro e acesso são pessoais e intransferíveis e o
            usuário é o único responsável por manter a confidencialidade dos
            seus dados e das atividades e serviços utilizados na
            Plataforma.&nbsp;
          </span>
        )}
      </p>
      <p
        style={{
          marginRight: '0cm',
          marginLeft: '0cm',
          fontSize: '11.0pt',
          fontFamily: 'Calibri, sans-serif',
          marginTop: '0cm',
          marginBottom: '8.0pt',
          margin: '0cm 0cm 8pt',
          lineHeight: 'normal',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
          verticalAlign: 'baseline',
        }}
      >
        {locale === 'en' ? (
          <span style={{ fontSize: 16 }}>
            The user must make responsible use of the Platform and the services
            provided, as well as log out of their account at the end of each
            access and use. ADSTART is not responsible for losses and damages
            resulting from improper sharing or misuse of the Platform.
          </span>
        ) : (
          <span style={{ fontSize: 16 }}>
            O usuário deverá fazer o acesso responsável da Plataforma e dos
            serviços disponibilizados, bem como fazer o logout da sua conta ao
            final de cada acesso e uso. A ADSTART não se responsabiliza por
            perdas e danos decorrentes de compartilhamentos indevidos ou pelo
            mau uso da Plataforma.
          </span>
        )}
      </p>
      <p
        style={{
          marginRight: '0cm',
          marginLeft: '0cm',
          fontSize: '11.0pt',
          fontFamily: 'Calibri, sans-serif',
          marginTop: '0cm',
          marginBottom: '8.0pt',
          margin: '0cm 0cm 8pt',
          lineHeight: 'normal',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
          verticalAlign: 'baseline',
        }}
      >
        {locale === 'en' ? (
          <span style={{ fontSize: 16 }}>
            The user must immediately inform ADSTART of any unauthorized use or
            any other security violation such as loss or misplacement of their
            data.
          </span>
        ) : (
          <span style={{ fontSize: 16 }}>
            O usuário deverá informar imediatamente a ADSTART em qualquer
            situação de uso não autorizado ou qualquer outra violação de
            segurança como perda ou extravio dos seus dados.
          </span>
        )}
      </p>
      <p
        style={{
          marginRight: '0cm',
          marginLeft: '0cm',
          fontSize: '11.0pt',
          fontFamily: 'Calibri, sans-serif',
          marginTop: '0cm',
          marginBottom: '8.0pt',
          margin: '0cm 0cm 8pt',
          lineHeight: 'normal',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
          verticalAlign: 'baseline',
        }}
      >
        <span style={{ fontSize: 16 }}>&nbsp;</span>
        <strong>
          <span style={{ fontSize: 16 }}>
            {locale === 'en'
              ? 'Platform Service Conditions and Changes'
              : 'Condições e Alterações nos Serviços da Plataforma'}
          </span>
        </strong>
      </p>
      <p
        style={{
          marginRight: '0cm',
          marginLeft: '0cm',
          fontSize: '11.0pt',
          fontFamily: 'Calibri, sans-serif',
          marginTop: '0cm',
          marginBottom: '8.0pt',
          margin: '0cm 0cm 8pt',
          lineHeight: '15.693334px',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
        }}
      >
        {locale === 'en' ? (
          <span
            style={{ fontSize: 16, lineHeight: '17.120001px', color: 'black' }}
          >
            ADSTART reserves the right to modify, suspend, terminate or
            discontinue any aspect of the Platform at any time, including the
            availability of any services, information, features or
            functionalities accessible through the Platform or limit features,
            functionalities or services or restrict access to parts or all of
            the Platform and/or services without prior notice and without
            implying any liability.
          </span>
        ) : (
          <>
            <span style={{ fontSize: 16, lineHeight: '17.120001px' }}>
              A&nbsp;
            </span>
            <span style={{ fontSize: 16, lineHeight: '17.120001px' }}>
              ADSTART se reserva o direito de&nbsp;
            </span>
            <span
              style={{
                fontSize: 16,
                lineHeight: '17.120001px',
                color: 'black',
              }}
            >
              modificar, suspender, terminar ou descontinuar qualquer aspecto da
              Plataforma a qualquer tempo, incluindo a disponibilidade de
              quaisquer serviços, informações, características ou
              funcionalidades acessíveis por meio da Plataforma ou limitar
              características, funcionalidades ou serviços ou restringir o
              acesso a partes ou à totalidade da Plataforma e/ou dos serviços
              sem prévia notificação e sem que isso implique em qualquer
              responsabilidade.
            </span>
          </>
        )}
      </p>
      <p
        style={{
          marginRight: '0cm',
          marginLeft: '0cm',
          fontSize: '11.0pt',
          fontFamily: 'Calibri, sans-serif',
          marginTop: '0cm',
          marginBottom: '8.0pt',
          margin: '0cm 0cm 8pt',
          lineHeight: 'normal',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
          verticalAlign: 'baseline',
        }}
      >
        {locale === 'en' ? (
          <span style={{ fontSize: 16, color: 'black' }}>
            ADSTART reserves the right to control and/or alter the appearance,
            development and/or operations of the Platform at its sole discretion
            at any time, as well as establish and modify procedures for user
            contact, without prior notification.
          </span>
        ) : (
          <>
            <span style={{ fontSize: 16, color: 'black' }}>A&nbsp;</span>
            <span style={{ fontSize: 16 }}>ADSTART se</span>
            <span style={{ fontSize: 16, color: 'black' }}>
              &nbsp;reserva o direito de, a qualquer tempo controlar e/ou
              alterar a aparência, o desenvolvimento e/ou operações da
              Plataforma a seu exclusivo critério, bem como estabelecer e
              modificar os procedimentos para o contato do usuário, sem a
              necessidade de notificação prévia.
            </span>
          </>
        )}
      </p>
      <p
        style={{
          marginRight: '0cm',
          marginLeft: '0cm',
          fontSize: '11.0pt',
          fontFamily: 'Calibri, sans-serif',
          marginTop: '0cm',
          marginBottom: '8.0pt',
          margin: '0cm 0cm 8pt',
          lineHeight: 'normal',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
          verticalAlign: 'baseline',
        }}
      >
        <strong>
          <span style={{ fontSize: 16 }}>
            {locale === 'en'
              ? 'Intellectual Property'
              : 'Da Propriedade Intelectual'}
          </span>
        </strong>
      </p>
      <p
        style={{
          marginRight: '0cm',
          marginLeft: '0cm',
          fontSize: '11.0pt',
          fontFamily: 'Calibri, sans-serif',
          marginTop: '0cm',
          marginBottom: '8.0pt',
          margin: '0cm 0cm 8pt',
          lineHeight: '14pt',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
        }}
      >
        {locale === 'en' ? (
          <span style={{ fontSize: 16 }}>
            Platform access and use of services that include intellectual
            property rights must be used in a manner restricted to the purpose
            of the contract signed between ADSTART and the client and in
            accordance with the conditions established in these&nbsp;
            <span style={{ fontSize: 16 }}>
              GENERAL TERMS AND CONDITIONS OF USE
            </span>
            , and the user must preserve intellectual property rights, copyright
            or industrial rights of trademarks, content, programs, as well as
            other intellectual property rights, copyright or industrial rights
            related or not to the Platform.
          </span>
        ) : (
          <span style={{ fontSize: 16 }}>
            O acesso à Plataforma e a utilização de serviços disponibilizados
            que contemplem direitos de propriedade intelectual deverão ser
            utilizados de forma restrita ao objeto do contrato firmado entre a
            ADSTART e o cliente e de acordo com as condições estabelecidas
            nestes&nbsp;
            <span style={{ fontSize: 16 }}>
              TERMOS GERAIS E CONDIÇÕES DE USO
            </span>
            , devendo o usuário preservar os direitos de propriedade
            intelectual, autoral ou industrial das marcas, conteúdos, programas,
            bem como outros direitos de propriedade intelectual, autoral ou
            industrial relacionados ou não com a Plataforma.
          </span>
        )}
      </p>
      <p
        style={{
          marginRight: '0cm',
          marginLeft: '0cm',
          fontSize: '11.0pt',
          fontFamily: 'Calibri, sans-serif',
          marginTop: '0cm',
          marginBottom: '8.0pt',
          margin: '0cm 0cm 8pt',
          lineHeight: '14pt',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
        }}
      >
        {locale === 'en' ? (
          <>
            <span style={{ fontSize: 16 }}>
              No provision or conditions of these&nbsp;
            </span>
            <span style={{ fontSize: 16 }}>
              GENERAL TERMS AND CONDITIONS OF USE&nbsp;
            </span>
            <span style={{ fontSize: 16 }}>
              or in the provision of services shall be interpreted as a form of
              license or assignment of intellectual property, copyright or
              industrial rights.&nbsp;
            </span>
          </>
        ) : (
          <>
            <span style={{ fontSize: 16 }}>
              Nenhuma disposição ou condições destes&nbsp;
            </span>
            <span style={{ fontSize: 16 }}>
              TERMOS GERAIS E CONDIÇÕES DE USO&nbsp;
            </span>
            <span style={{ fontSize: 16 }}>
              ou na prestação dos serviços deverá ser interpretada como forma de
              licença ou cessão de direitos de propriedade intelectual, autoral
              ou industrial.&nbsp;
            </span>
          </>
        )}
      </p>
      <p
        style={{
          marginRight: '0cm',
          marginLeft: '0cm',
          fontSize: '11.0pt',
          fontFamily: 'Calibri, sans-serif',
          marginTop: '0cm',
          marginBottom: '8.0pt',
          margin: '0cm 0cm 8pt',
          lineHeight: '14pt',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
        }}
      >
        {locale === 'en' ? (
          <span style={{ fontSize: 16 }}>
            The user may not, in any way, copy, reproduce, adapt, modify,
            alienate, sell, assign, lease, sublease, transfer, use, copy,
            distribute, allow third party access, make Platform content
            available for free or for a fee, transform, plagiarize, or modify
            the Platform in any way, decompile or reverse engineer the Platform,
            in whole or in part, or use it for any purpose other than what was
            specifically authorized, nor allow any third party to do so.
          </span>
        ) : (
          <span style={{ fontSize: 16 }}>
            O usuário não poderá, de forma alguma, copiar, reproduzir, adaptar,
            modificar, alienar, vender, ceder, locar, sublocar, transferir,
            utilizar, copiar, distribuir, permitir o acesso de terceiro,
            disponibilizar os conteúdos da Plataforma de forma gratuita ou
            onerosa, transformar, plagiar, ou modificar de quaisquer formas a
            Plataforma, descompilar ou fazer engenharia reversa da Plataforma,
            no todo ou em parte, ou usar para qualquer propósito diverso do que
            lhe foi especificamente autorizado, tampouco permitir que qualquer
            terceiro o faça.
          </span>
        )}
      </p>
      <p
        style={{
          marginRight: '0cm',
          marginLeft: '0cm',
          fontSize: '11.0pt',
          fontFamily: 'Calibri, sans-serif',
          marginTop: '0cm',
          marginBottom: '8.0pt',
          margin: '0cm 0cm 8pt',
          lineHeight: 'normal',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
          verticalAlign: 'baseline',
        }}
      >
        <strong>
          <span style={{ fontSize: 16, color: 'black' }}>
            {locale === 'en' ? 'Responsibilities' : 'Responsabilidades'}
          </span>
        </strong>
      </p>
      <p
        style={{
          marginRight: '0cm',
          marginLeft: '0cm',
          fontSize: '11.0pt',
          fontFamily: 'Calibri, sans-serif',
          marginTop: '0cm',
          marginBottom: '8.0pt',
          margin: '0cm 0cm 8pt',
          lineHeight: 'normal',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
          verticalAlign: 'baseline',
        }}
      >
        {locale === 'en' ? (
          <span style={{ fontSize: 16, color: 'black' }}>
            The user acknowledges that the provided services may contain
            technical problems or other limitations inherent to internet use,
            and <span style={{ fontSize: 16 }}>ADSTART</span> shall not be
            liable for any damages that may arise from technical problems,
            limitations, bugs or viruses in connection with user access or the
            services provided.
          </span>
        ) : (
          <>
            <span style={{ fontSize: 16, color: 'black' }}>
              O usuário reconhece que os serviços disponibilizados podem conter
              problemas técnicos ou outras limitações inerentes ao uso da
              internet, não cabendo a&nbsp;
            </span>
            <span style={{ fontSize: 16 }}>ADSTART&nbsp;</span>
            <span style={{ fontSize: 16, color: 'black' }}>
              nenhuma responsabilidade por quaisquer danos que possam surgir a
              partir de problemas técnicos, limitações, bugs ou vírus em conexão
              com o acesso do usuário ou aos serviços disponibilizados.
            </span>
          </>
        )}
      </p>
      <p
        style={{
          marginRight: '0cm',
          marginLeft: '0cm',
          fontSize: '11.0pt',
          fontFamily: 'Calibri, sans-serif',
          marginTop: '0cm',
          marginBottom: '8.0pt',
          margin: '0cm 0cm 8pt',
          lineHeight: 'normal',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
          verticalAlign: 'baseline',
        }}
      >
        {locale === 'en' ? (
          <span style={{ fontSize: 16, color: 'black' }}>
            Under no circumstances shall ADSTART be liable for any damages of
            any nature that may be directly or indirectly attributable to
            improper use or inability to use the Platform or any information,
            data, software or service provided.
          </span>
        ) : (
          <>
            <span style={{ fontSize: 16, color: 'black' }}>
              Em nenhuma hipótese a&nbsp;
            </span>
            <span style={{ fontSize: 16 }}>ADSTART&nbsp;</span>
            <span style={{ fontSize: 16, color: 'black' }}>
              será responsável por quaisquer danos, de qualquer natureza, que
              possam, direta ou indiretamente, ser atribuíveis ao uso indevido
              ou à incapacidade de uso da Plataforma ou quaisquer informações,
              dados, software ou serviço prestado.&nbsp;
            </span>
          </>
        )}
      </p>
      <p
        style={{
          marginRight: '0cm',
          marginLeft: '0cm',
          fontSize: '11.0pt',
          fontFamily: 'Calibri, sans-serif',
          marginTop: '0cm',
          marginBottom: '8.0pt',
          margin: '0cm 0cm 8pt',
          lineHeight: '15.693334px',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
        }}
      >
        {locale === 'en' ? (
          <span style={{ fontSize: 16, lineHeight: '17.120001px' }}>
            Considering that ADSTART interacts with third-party services such as
            Google Ads, Google Analytics, Google Search Console, Meta, TikTok,
            Magazord, Tray, Nuvemshop, Shopify, VNDA and other equivalent tools
            and that depend on the continuous availability of APIs under
            reasonable conditions for the availability of contracted services,
            there may be interruption in the provision of such resources,
            without right to refund, credit or other compensation to the
            contractor.
          </span>
        ) : (
          <>
            <span style={{ fontSize: 16, lineHeight: '17.120001px' }}>
              Considerando que a&nbsp;
            </span>
            <span style={{ fontSize: 16, lineHeight: '17.120001px' }}>
              ADSTART interage como serviços de terceiros como Google Ads,
              Google Analytics, Google Search Console, Meta, TikTok, Magazord,
              Tray, Nuvemshop, Shopify, VNDA e&nbsp;
            </span>
            <span
              style={{
                fontSize: 16,
                lineHeight: '17.120001px',
                color: 'rgb(34, 34, 34)',
              }}
            >
              e outras ferramentas equivalentes
            </span>
            <span
              style={{
                fontSize: 16,
                lineHeight: '17.120001px',
                color: 'rgb(34, 34, 34)',
              }}
            >
              &nbsp;e&nbsp;
            </span>
            <span
              style={{
                fontSize: 16,
                lineHeight: '17.120001px',
                color: 'rgb(34, 34, 34)',
              }}
            >
              que dependem da disponibilidade contínua das APIs em condições
              razoáveis para a disponibilidade dos serviços contatados, poderá
              haver interrupção do fornecimento de tais recursos, sem direito de
              reembolso, crédito ou outras compensações ao contratante.
            </span>
          </>
        )}
      </p>
      <p
        style={{
          marginRight: '0cm',
          marginLeft: '0cm',
          fontSize: '11.0pt',
          fontFamily: 'Calibri, sans-serif',
          marginTop: '0cm',
          marginBottom: '8.0pt',
          margin: '0cm 0cm 8pt',
          lineHeight: 'normal',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
          verticalAlign: 'baseline',
        }}
      >
        {locale === 'en' ? (
          <>
            <span style={{ fontSize: 16, color: 'black' }}>
              ADSTART works to maintain the Platform and services operational,
              however, all online services are subject to occasional
              interruptions and downtimes. ADSTART is not responsible for any
              interruption or loss resulting from such interruptions or
              downtimes.
            </span>
          </>
        ) : (
          <>
            <span style={{ fontSize: 16, color: 'black' }}>A&nbsp;</span>
            <span style={{ fontSize: 16 }}>ADSTART&nbsp;</span>
            <span style={{ fontSize: 16, color: 'black' }}>
              trabalha e para manter a Plataforma e os serviços em
              funcionamento, contudo, todos os serviços online estão sujeitos a
              interrupções e paradas ocasionais. A&nbsp;
            </span>
            <span style={{ fontSize: 16 }}>ADSTART&nbsp;</span>
            <span style={{ fontSize: 16, color: 'black' }}>
              não se responsabiliza por nenhuma interrupção ou perda decorrentes
              de tais interrupções ou paradas.
            </span>
          </>
        )}
      </p>
      <p
        style={{
          marginRight: '0cm',
          marginLeft: '0cm',
          fontSize: '11.0pt',
          fontFamily: 'Calibri, sans-serif',
          marginTop: '0cm',
          marginBottom: '8.0pt',
          margin: '0cm 0cm 8pt',
          lineHeight: 'normal',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
          verticalAlign: 'baseline',
        }}
      >
        <strong>
          <span style={{ fontSize: 16 }}>
            {locale === 'en'
              ? 'Acceptable Use Policy'
              : 'Política Aceitável de Uso'}
          </span>
        </strong>
      </p>
      <p
        style={{
          marginRight: '0cm',
          marginLeft: '0cm',
          fontSize: '11.0pt',
          fontFamily: 'Calibri, sans-serif',
          marginTop: '0cm',
          marginBottom: '8.0pt',
          margin: '0cm 0cm 8pt',
          lineHeight: 'normal',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
          verticalAlign: 'baseline',
        }}
      >
        <span style={{ fontSize: 16, color: 'black' }}>
          {locale === 'en' ? 'The user may not:' : 'O usuário não poderá:'}
        </span>
      </p>
      <ol start={1} style={{ listStyleType: 'lower-alpha', marginLeft: 8 }}>
        {locale === 'en' ? (
          <>
            <li>
              <span style={{ fontSize: 16, fontFamily: 'Calibri, sans-serif' }}>
                Use the Platform or any services and information for private
                purposes or personal reasons, but only for the normal business
                activities of the contracting company;
              </span>
            </li>
            <li>
              <span style={{ fontSize: 16, fontFamily: 'Calibri, sans-serif' }}>
                Use the Platform and any content or service for illicit purposes
                or publish, post, distribute or disseminate defamatory,
                transgressive, obscene, indecent or illegal materials or
                information through our services provided or in the use of the
                Platform;
              </span>
            </li>
            <li>
              <span style={{ fontSize: 16, fontFamily: 'Calibri, sans-serif' }}>
                Upload files, data or any other materials not owned or licensed;
              </span>
            </li>
            <li>
              <span style={{ fontSize: 16, fontFamily: 'Calibri, sans-serif' }}>
                Interfere with the normal operation of the Platform, content and
                services or in the use and access of other parties.
              </span>
            </li>
          </>
        ) : (
          <>
            <li>
              <span style={{ fontSize: 16, fontFamily: 'Calibri, sans-serif' }}>
                Usar a Plataforma ou quaisquer serviços e informações para fins
                particulares ou razões pessoais, mas somente para as atividades
                normais de negócios da empresa contratante;
              </span>
            </li>
            <li>
              <span style={{ fontSize: 16, fontFamily: 'Calibri, sans-serif' }}>
                Usar a Plataforma e qualquer conteúdo ou serviço para fins
                ilícitos ou publicar, postar, distribuir ou disseminar materiais
                ou informações difamatórias, transgressoras, obscenas,
                indecentes ou ilegais através dos nossos serviços
                disponibilizados ou no uso da Plataforma;
              </span>
            </li>
            <li>
              <span style={{ fontSize: 16, fontFamily: 'Calibri, sans-serif' }}>
                Fazer upload de arquivos, dados ou quaisquer outros materiais
                não pertencentes ou licenciados;
              </span>
            </li>
            <li>
              <span style={{ fontSize: 16, fontFamily: 'Calibri, sans-serif' }}>
                Interferir no funcionamento normal da Plataforma, conteúdos e
                serviços ou no uso e acesso de outras partes.
              </span>
            </li>
          </>
        )}
      </ol>
      <p
        style={{
          marginRight: '0cm',
          marginLeft: '0cm',
          fontSize: '11.0pt',
          fontFamily: 'Calibri, sans-serif',
          marginTop: '0cm',
          marginBottom: '8.0pt',
          margin: '0cm 0cm 8pt',
          lineHeight: 'normal',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
          verticalAlign: 'baseline',
        }}
      >
        {locale === 'en' ? (
          <>
            <span style={{ fontSize: 16, color: 'black' }}>
              ADSTART reserves the right to immediately suspend or block access
              to the Platform or any service, and remove any information or data
              that we consider to be in violation of any of these&nbsp;
            </span>
            <span style={{ fontSize: 16 }}>
              GENERAL TERMS AND CONDITIONS OF USE,&nbsp;
            </span>
            <span style={{ fontSize: 16 }}>
              commercial proposal or signed contract
            </span>
            <span style={{ fontSize: 16, color: 'black' }}>
              , without prior notice and make the information available when
              requested by public agencies or by court order.
            </span>
          </>
        ) : (
          <>
            <span style={{ fontSize: 16, color: 'black' }}>A&nbsp;</span>
            <span style={{ fontSize: 16 }}>ADSTART se&nbsp;</span>
            <span style={{ fontSize: 16, color: 'black' }}>
              reserva o direito de suspender ou bloquear imediatamente o acesso
              à Plataforma ou a qualquer serviço, e remover quaisquer
              informações ou dados que considerarmos uma violação de qualquer um
              destes&nbsp;
            </span>
            <span style={{ fontSize: 16 }}>
              TERMOS GERAIS E CONDIÇÕES DE USO,&nbsp;
            </span>
            <span style={{ fontSize: 16 }}>
              da proposta comercial ou do contrato firmado
            </span>
            <span style={{ fontSize: 16, color: 'black' }}>
              , sem aviso prévio e disponibilizar a informação quando solicitada
              por órgãos públicos ou por ordem judicial.
            </span>
          </>
        )}
      </p>
      <p
        style={{
          marginRight: '0cm',
          marginLeft: '0cm',
          fontSize: '11.0pt',
          fontFamily: 'Calibri, sans-serif',
          marginTop: '0cm',
          marginBottom: '8.0pt',
          margin: '0cm 0cm 8pt',
          lineHeight: 'normal',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
          verticalAlign: 'baseline',
        }}
      >
        <strong>
          <span style={{ fontSize: 16 }}>
            {locale === 'en'
              ? 'Personal Data Processing'
              : 'Tratamento de dados Pessoais'}
          </span>
        </strong>
      </p>
      <p
        style={{
          marginRight: '0cm',
          marginLeft: '0cm',
          fontSize: '11.0pt',
          fontFamily: 'Calibri, sans-serif',
          marginTop: '0cm',
          marginBottom: '8.0pt',
          margin: '0cm 0cm 8pt',
          lineHeight: '15.693334px',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
        }}
      >
        {locale === 'en' ? (
          <>
            <span style={{ fontSize: 16, lineHeight: '17.120001px' }}>
              ADSTART
            </span>{' '}
            is committed to protecting the fundamental rights of freedom and
            privacy regarding the processing of personal data and is obligated
            to fully comply with personal data protection regulations. The
            processing of personal data is published in our Privacy Notice (
            <a
              style={{ color: 'blue', textDecoration: 'underline' }}
              href="https://adstart.com.br/en/privacy-policy"
            >
              link
            </a>
            ).
          </>
        ) : (
          <>
            A&nbsp;
            <span style={{ fontSize: 16, lineHeight: '17.120001px' }}>
              ADSTART
            </span>{' '}
            se compromete a proteger os direitos fundamentais de liberdade e de
            privacidade, relativos ao tratamento de dados pessoais e se obriga a
            respeitar integralmente as normas sobre proteção de dados pessoais,
            sobretudo, a Lei 13.709/2018 – LGPD. O tratamento de dados pessoais
            está publicado em nosso Aviso de Privacidade (
            <a
              style={{ color: 'blue', textDecoration: 'underline' }}
              href="https://adstart.com.br/pt/privacy-policy"
            >
              link
            </a>
            ).
          </>
        )}
      </p>
      <p
        style={{
          marginRight: '0cm',
          marginLeft: '0cm',
          fontSize: '11.0pt',
          fontFamily: 'Calibri, sans-serif',
          marginTop: '0cm',
          marginBottom: '8.0pt',
          margin: '0cm 0cm 8pt',
          lineHeight: '15.4px',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
        }}
      >
        {locale === 'en' ? (
          <>
            <span style={{ fontSize: 16, lineHeight: '16.799999px' }}>
              ADSTART&nbsp;
            </span>
            will process personal data limited to activities necessary to
            achieve the purposes of executing the contract and contracted
            service, using them, when applicable, in compliance with legal or
            regulatory obligations, in the regular exercise of rights or by
            determination of the National Data Protection Authority.
          </>
        ) : (
          <>
            A&nbsp;
            <span style={{ fontSize: 16, lineHeight: '16.799999px' }}>
              ADSTART&nbsp;
            </span>
            tratará dados pessoais limitado às atividades necessárias ao
            atingimento das finalidades de execução do contrato e do serviço
            contratado, utilizando-os, quando seja o caso, em cumprimento de
            obrigação legal ou regulatória, no exercício regular de direito ou
            por determinação da Autoridade Nacional de Proteção de Dados
            Pessoais – ANPD.
          </>
        )}
      </p>
      <p
        style={{
          marginRight: '0cm',
          marginLeft: '0cm',
          fontSize: 'medium',
          fontFamily: '"Times New Roman", serif',
          margin: '0cm',
          color: 'black',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
        }}
      >
        {locale === 'en' ? (
          <span style={{ fontFamily: 'Calibri, sans-serif' }}>
            Privacy and security of personal data are very important to ADSTART.
            Our security program is comprehensive with the implementation of
            appropriate technical and organizational measures to protect
            personal data and ensure confidentiality and integrity, aiming that
            they are not improperly disclosed or shared. It is important for
            users to protect their account by creating a strong password, not
            sharing it with anyone, limiting access through their devices and
            avoiding automatic platform access.
          </span>
        ) : (
          <>
            <span style={{ fontFamily: 'Calibri, sans-serif' }}>
              A privacidade e a segurança dos dados pessoais são muito
              importantes para a&nbsp;
            </span>
            <span style={{ fontFamily: 'Calibri, sans-serif' }}>
              ADSTART.&nbsp;&nbsp;Nosso programa de segurança&nbsp;
            </span>
            <span style={{ fontFamily: 'Calibri, sans-serif' }}>é&nbsp;</span>
            <span style={{ fontFamily: 'Calibri, sans-serif' }}>
              complexo com a implementação de medidas técnicas e organizacionais
              apropriadas para proteger os dados pessoais e garantir a
              confidencialidade e integridade, visando que não sejam divulgados
              ou compartilhados indevidamente.&nbsp;
            </span>
            <span
              style={{
                fontFamily: 'Calibri, sans-serif',
                color: 'rgb(34, 35, 38)',
              }}
            >
              Importante o usuário proteger sua conta, com criação de senha
              forte, não compartilhando com ninguém, limitando o acesso através
              dos seus dispositivos e evitando o acesso automático a plataforma.
            </span>
          </>
        )}
      </p>
      <p
        style={{
          marginRight: '0cm',
          marginLeft: '0cm',
          fontSize: 'medium',
          fontFamily: '"Times New Roman", serif',
          margin: '0cm',
          color: 'black',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
        }}
      >
        {locale === 'en' ? (
          <span
            style={{
              fontFamily: 'Calibri, sans-serif',
              color: 'rgb(34, 35, 38)',
            }}
          >
            &nbsp;
          </span>
        ) : (
          <span
            style={{
              fontFamily: 'Calibri, sans-serif',
              color: 'rgb(34, 35, 38)',
            }}
          >
            &nbsp;
          </span>
        )}
      </p>
      <p
        style={{
          marginRight: '0cm',
          marginLeft: '0cm',
          fontSize: '11.0pt',
          fontFamily: 'Calibri, sans-serif',
          marginTop: '0cm',
          marginBottom: '8.0pt',
          margin: '0cm 0cm 8pt',
          lineHeight: '15.693334px',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
        }}
      >
        {locale === 'en' ? (
          <>
            <span style={{ fontSize: 16, lineHeight: '17.120001px' }}>
              ADSTART&nbsp;
            </span>
            is committed to complying with the obligations provided for in the
            LGPD regarding the exercise of personal data subject rights and in
            compliance with determinations from the National Data Protection
            Authority - ANPD, Judiciary, Public Ministry, Procon and/or other
            public authorities.
          </>
        ) : (
          <>
            A&nbsp;
            <span style={{ fontSize: 16, lineHeight: '17.120001px' }}>
              ADSTART&nbsp;
            </span>
            compromete-se com o cumprimento das obrigações previstas na LGPD
            quanto ao atendimento do exercício de direito de titular de dados
            pessoais e no atendimento de determinações da Autoridade Nacional de
            Proteção de Dados – ANPD, Poder Judiciário, Ministério Público,
            Procon e/ou outras autoridades públicas.
          </>
        )}
      </p>
      <p
        style={{
          marginRight: '0cm',
          marginLeft: '0cm',
          fontSize: '11.0pt',
          fontFamily: 'Calibri, sans-serif',
          marginTop: '0cm',
          marginBottom: '8.0pt',
          margin: '0cm 0cm 8pt',
          lineHeight: 'normal',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
          verticalAlign: 'baseline',
        }}
      >
        <strong>
          <span style={{ fontSize: 16 }}>
            {locale === 'en' ? 'General Provisions' : 'Disposições Gerais'}
          </span>
        </strong>
      </p>
      <p
        style={{
          marginRight: '0cm',
          marginLeft: '0cm',
          fontSize: '11.0pt',
          fontFamily: 'Calibri, sans-serif',
          marginTop: '0cm',
          marginBottom: '8.0pt',
          margin: '0cm 0cm 8pt',
          lineHeight: 'normal',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
          verticalAlign: 'baseline',
        }}
      >
        {locale === 'en' ? (
          <>
            <span style={{ fontSize: 16, color: 'black' }}>
              The user and contractor may not assign, sublicense, subcontract,
              transfer or dispose of any rights and obligations under
              these&nbsp;
            </span>
            <span style={{ fontSize: 16 }}>
              GENERAL TERMS AND CONDITIONS OF USE
            </span>
            <span style={{ fontSize: 16, color: 'black' }}>
              &nbsp;without the prior consent of&nbsp;
            </span>
            <span style={{ fontSize: 16 }}>ADSTART</span>
            <span style={{ fontSize: 16, color: 'black' }}>.&nbsp;</span>
          </>
        ) : (
          <>
            <span style={{ fontSize: 16, color: 'black' }}>
              O usuário e o contratante não poderão ceder, sublicenciar,
              subcontratar, transferir ou dispor de quaisquer direitos e
              obrigações no âmbito destes&nbsp;
            </span>
            <span style={{ fontSize: 16 }}>
              TERMOS GERAIS E CONDIÇÕES DE USO
            </span>
            <span style={{ fontSize: 16, color: 'black' }}>
              &nbsp;sem o consentimento prévio da&nbsp;
            </span>
            <span style={{ fontSize: 16 }}>ADSTART</span>
            <span style={{ fontSize: 16, color: 'black' }}>.&nbsp;</span>
          </>
        )}
      </p>
      <p
        style={{
          marginRight: '0cm',
          marginLeft: '0cm',
          fontSize: '11.0pt',
          fontFamily: 'Calibri, sans-serif',
          marginTop: '0cm',
          marginBottom: '8.0pt',
          margin: '0cm 0cm 8pt',
          lineHeight: 'normal',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
          verticalAlign: 'baseline',
        }}
      >
        {locale === 'en' ? (
          <span style={{ fontSize: 16, color: 'black' }}>
            The obligations, taxes and other charges that are due, directly or
            indirectly, by virtue of amounts paid or received through this
            Agreement or by virtue of its execution shall be the responsibility
            of the taxpayer as defined in the tax regulations, without right to
            reimbursement.
          </span>
        ) : (
          <span style={{ fontSize: 16, color: 'black' }}>
            As obrigações e tributos e demais encargos que forem devidos, direta
            ou indiretamente, em virtude dos valores pagos ou recebidos através
            deste Contrato ou em virtude de sua execução serão de
            responsabilidade do contribuinte assim definido na norma tributária,
            sem direito a reembolso.
          </span>
        )}
      </p>
      <p
        style={{
          marginRight: '0cm',
          marginLeft: '0cm',
          fontSize: '11.0pt',
          fontFamily: 'Calibri, sans-serif',
          marginTop: '0cm',
          marginBottom: '8.0pt',
          margin: '0cm 0cm 8pt',
          lineHeight: 'normal',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
          verticalAlign: 'baseline',
        }}
      >
        {locale === 'en' ? (
          <>
            <span style={{ fontSize: 16, color: 'black' }}>These&nbsp;</span>
            <span style={{ fontSize: 16 }}>
              GENERAL TERMS AND CONDITIONS OF USE
            </span>
            <span style={{ fontSize: 16 }}>
              &nbsp;together with the commercial proposal and signed contract
            </span>
            <span style={{ fontSize: 16, color: 'black' }}>
              contain the entire agreement regarding the services provided and
              the access and use of the Platform and supersede all prior
              agreements.
            </span>
          </>
        ) : (
          <>
            <span style={{ fontSize: 16, color: 'black' }}>Estes&nbsp;</span>
            <span style={{ fontSize: 16 }}>
              TERMOS GERAIS E CONDIÇÕES DE USO
            </span>
            <span style={{ fontSize: 16 }}>
              &nbsp;em conjunto com a proposta comercial e contrato firmado
            </span>
            <span style={{ fontSize: 16, color: 'black' }}>
              contém o acordo integral entre em relação aos serviços prestados e
              o acesso e uso da Plataforma e substituem todos os acordos
              anteriores.
            </span>
          </>
        )}
      </p>
      <p
        style={{
          marginRight: '0cm',
          marginLeft: '0cm',
          fontSize: '11.0pt',
          fontFamily: 'Calibri, sans-serif',
          marginTop: '0cm',
          marginBottom: '8.0pt',
          margin: '0cm 0cm 8pt',
          lineHeight: 'normal',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
          verticalAlign: 'baseline',
        }}
      >
        {locale === 'en' ? (
          <>
            <span style={{ fontSize: 16, color: 'black' }}>
              In case of declaration of nullity, illegality or invalidation of
              any part of these&nbsp;
            </span>
            <span style={{ fontSize: 16 }}>
              GENERAL TERMS AND CONDITIONS OF USE
            </span>
            <span style={{ fontSize: 16, color: 'black' }}>
              &nbsp;in any aspect, under the law of any jurisdiction, it will
              not affect or impair the legality, validity or enforcement in that
              or any other jurisdiction of any other provision of these&nbsp;
            </span>
            <span style={{ fontSize: 16 }}>
              GENERAL TERMS AND CONDITIONS OF USE
            </span>
            <span style={{ fontSize: 16, color: 'black' }}>.</span>
          </>
        ) : (
          <>
            <span style={{ fontSize: 16, color: 'black' }}>
              No caso de declaração de nulidade, ilegalidade ou invalidação de
              parte destes&nbsp;
            </span>
            <span style={{ fontSize: 16 }}>
              TERMOS GERAIS E CONDIÇÕES DE USO
            </span>
            <span style={{ fontSize: 16, color: 'black' }}>
              &nbsp;em qualquer aspecto, sob a lei de qualquer jurisdição, não
              afetará ou prejudicará a legalidade, validade ou execução nessa ou
              em qualquer outra jurisdição de qualquer outra disposição
              destes&nbsp;
            </span>
            <span style={{ fontSize: 16 }}>
              TERMOS GERAIS E CONDIÇÕES DE USO
            </span>
            <span style={{ fontSize: 16, color: 'black' }}>.</span>
          </>
        )}
      </p>
      <p
        style={{
          marginRight: '0cm',
          marginLeft: '0cm',
          fontSize: '11.0pt',
          fontFamily: 'Calibri, sans-serif',
          marginTop: '0cm',
          marginBottom: '8.0pt',
          margin: '0cm 0cm 8pt',
          lineHeight: 'normal',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
          verticalAlign: 'baseline',
        }}
      >
        {locale === 'en' ? (
          <>
            <span style={{ fontSize: 16, color: 'black' }}>
              Any improvements or additions to the Platform or services will be
              subject to these&nbsp;
            </span>
            <span style={{ fontSize: 16 }}>
              GENERAL TERMS AND CONDITIONS OF USE
            </span>
            <span style={{ fontSize: 16, color: 'black' }}>
              , unless expressly stated otherwise.&nbsp;
            </span>
          </>
        ) : (
          <>
            <span style={{ fontSize: 16, color: 'black' }}>
              Quaisquer melhorias ou adições à Plataforma ou aos serviços
              estarão sujeitos a estes&nbsp;
            </span>
            <span style={{ fontSize: 16 }}>
              TERMOS GERAIS E CONDIÇÕES DE USO
            </span>
            <span style={{ fontSize: 16, color: 'black' }}>
              , a não ser que se estabeleça expressamente de outra forma.&nbsp;
            </span>
          </>
        )}
      </p>
      <p
        style={{
          marginRight: '0cm',
          marginLeft: '0cm',
          fontSize: '11.0pt',
          fontFamily: 'Calibri, sans-serif',
          marginTop: '0cm',
          marginBottom: '8.0pt',
          margin: '0cm 0cm 8pt',
          lineHeight: 'normal',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
          verticalAlign: 'baseline',
        }}
      >
        {locale === 'en' ? (
          <>
            <span style={{ fontSize: 16, color: 'black' }}>These&nbsp;</span>
            <span style={{ fontSize: 16 }}>
              GENERAL TERMS AND CONDITIONS OF USE
            </span>
            <span style={{ fontSize: 16, color: 'black' }}>
              &nbsp;and all relationships arising from them are subject to
              current legislation, with the jurisdiction of Blumenau/SC being
              chosen to resolve any controversy arising from this instrument.
            </span>
          </>
        ) : (
          <>
            <span style={{ fontSize: 16, color: 'black' }}>Estes&nbsp;</span>
            <span style={{ fontSize: 16 }}>
              TERMOS GERAIS E CONDIÇÕES DE USO
            </span>
            <span style={{ fontSize: 16, color: 'black' }}>
              &nbsp;e todas as relações dele decorrentes são submetidas à
              legislação vigente, sendo eleito o foro da Comarca de Blumenau/SC
              para dirimir qualquer controvérsia decorrente deste instrumento.
            </span>
          </>
        )}
      </p>
      <p
        style={{
          marginRight: '0cm',
          marginLeft: '0cm',
          fontSize: '11.0pt',
          fontFamily: 'Calibri, sans-serif',
          marginTop: '0cm',
          marginBottom: '8.0pt',
          margin: '0cm 0cm 8pt',
          lineHeight: 'normal',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
          verticalAlign: 'baseline',
        }}
      >
        <span style={{ fontSize: 16, color: 'black' }}>&nbsp;</span>
      </p>
      <p
        style={{
          marginRight: '0cm',
          marginLeft: '0cm',
          fontSize: '11.0pt',
          fontFamily: 'Calibri, sans-serif',
          marginTop: '0cm',
          marginBottom: '8.0pt',
          margin: '0cm 0cm 8pt',
          lineHeight: 'normal',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
          verticalAlign: 'baseline',
        }}
      >
        <span style={{ fontSize: 16, color: 'black' }}>
          {locale === 'en' ? 'August/2023' : 'Agosto/2023'}
        </span>
      </p>
      <p
        style={{
          marginRight: '0cm',
          marginLeft: '0cm',
          fontSize: '11.0pt',
          fontFamily: 'Calibri, sans-serif',
          marginTop: '0cm',
          marginBottom: '8.0pt',
          margin: '0cm 0cm 8pt',
          lineHeight: 'normal',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textIndent: 0,
          textDecoration: 'none',
          textAlign: 'justify',
          verticalAlign: 'baseline',
        }}
      >
        <span style={{ fontSize: 16, color: 'black' }}>
          {locale === 'en' ? 'Version 01.' : 'Versão 01.'}
        </span>
      </p>
      <p
        style={{
          marginRight: '0cm',
          marginLeft: '0cm',
          fontSize: '11.0pt',
          fontFamily: 'Calibri, sans-serif',
          marginTop: '0cm',
          marginBottom: '8.0pt',
          margin: '0cm 0cm 8pt',
          lineHeight: '15.693334px',
          color: 'rgb(0, 0, 0)',
          fontStyle: 'normal',
          fontWeight: 400,
          textAlign: 'start',
          textIndent: 0,
          textDecoration: 'none',
        }}
      >
        <span
          style={{ fontSize: 16, lineHeight: '17.120001px', color: 'black' }}
        >
          &nbsp;
        </span>
      </p>
    </>
  );
}
